import { FlexibleBlockBrick, FlexibleBlockModifierBrick } from '@nx-frontend/shared/types';

export const modifyBricks = (
  bricks: FlexibleBlockBrick[],
  modifierBricks?: FlexibleBlockModifierBrick[]
): FlexibleBlockBrick[] => {
  if (modifierBricks == null || modifierBricks.length === 0) {
    return bricks;
  }
  return bricks.map((brick) => {
    return modifierBricks.reduce<FlexibleBlockBrick>((acc, modify) => {
      if (modify.brickType !== brick.brickType) {
        return acc;
      }
      return { ...acc, ...modify } as typeof brick;
    }, brick);
  });
};
